const INITIAL_STATE = {
  data: {},
  errors: {},

}
const GetStaffFieldById = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_FIELD_STAFFF_LIST_BY_ID_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_FIELD_STAFFF_LIST_BY_ID_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default GetStaffFieldById;